import { useVdFeatureManager } from '../../../../ng-compat/hooks'
import { SIMULATED_READER_FLAG } from '../helpers/lspayConstants'

// Returns whether we should use the simulated reader (based on a flag and localStorage)
export const useShouldUseSimulator = () => {
  const flagAllowsSimulator = useVdFeatureManager().get(SIMULATED_READER_FLAG)
  if (!flagAllowsSimulator) return false
  // when the flag allows the simulator, enable using a real device based on a browser setting
  return localStorage.VEND_WR_LSPAY_USE_REAL_DEVICE !== 'true'
}
